(function () {
  var MARK_PATH =
    'M32.7405 9.62599V7.14349C32.7405 6.78885 32.3841 6.58619 32.0786 6.78885L29.329 8.41007C28.8198 8.71405 28.4634 9.27134 28.4634 9.8793V11.5005V21.7345V22.2411V22.2411V22.2411C29.5327 22.2411 31.6713 22.2411 32.6896 22.2411V21.7345V11.9565C33.3516 9.27134 37.5778 14.3883 39.971 6.4342C37.2214 8.46073 34.0135 5.82625 32.7405 9.62599Z';

  class LoaderAnimation {
    init() {
      this.createContainer();
    }

    createContainer() {
      if (document.getElementById('loader-animation')) return;

      var container = document.createElement('div');
      container.id = 'loader-animation';
      container.setAttribute('role', 'status');
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-label', 'Loading');
      container.innerHTML =
        '<div class="fk-loader" aria-hidden="true">' +
        '<svg class="fk-loader__mark" viewBox="28 6 14 17" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="' +
        MARK_PATH +
        '" fill="currentColor"></path>' +
        '</svg>' +
        '</div>';

      document.body.appendChild(container);
    }

    show() {
      this.createContainer();
      document.body.classList.add('loader-active');
      var container = document.getElementById('loader-animation');
      if (container) container.classList.add('visible');
    }

    hide() {
      document.body.classList.remove('loader-active');
      var container = document.getElementById('loader-animation');
      if (container) container.classList.remove('visible');
    }

    play() {
      this.show();
    }

    stop() {
      this.hide();
    }
  }

  window.LoaderAnimation = LoaderAnimation;
  window.loaderAnimation = new LoaderAnimation();
  window.loaderAnimation.init();
})();
